// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3PHCj","col":"styles_col__2Hdb6","fulfillmentStatus":"styles_fulfillmentStatus__3HKkO","emailCol":"styles_emailCol__bRrKz"};